import React, { useState } from 'react';
import { format } from 'date-fns';
import { Popover, PopoverTrigger, PopoverContent } from '../ui/Popover';
import { Calendar } from '../ui/Calender';
import { CalendarIcon } from 'lucide-react';
import { cn } from '../../lib/cn';

export const DatePicker = ({
    value,
    onChange,
    placeholder = "25-Feb",
    disabled = false,
    className = "",
    fromYear = 2024,
    toYear = 2030,
    disablePastDates = false,
    disableSundays = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const formatDateShort = (date) => {
        if (!date) return "";
        const d = new Date(date);
        const currentYear = new Date().getFullYear();
        const targetYear = d.getFullYear();
        const day = d.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[d.getMonth()];

        if (targetYear !== currentYear) {
            const yearShort = targetYear.toString().slice(-2);
            return `${day}-${month}-${yearShort}`;
        }
        return `${day}-${month}`;
    };

    return (
        <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger asChild>
                <button
                    type="button"
                    disabled={disabled}
                    className={cn(
                        "w-full h-11 px-3 py-2 text-left border-2 border-border rounded-[5px] bg-white hover:border-primary transition-all flex items-center justify-between",
                        !value && "text-gray-400",
                        disabled && "opacity-50 cursor-not-allowed",
                        className
                    )}
                >
                    <span className="text-[14px]">{value ? formatDateShort(value) : placeholder}</span>
                    <CalendarIcon className="h-4 w-4 text-muted-foreground" />
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                    mode="single"
                    selected={value}
                    onSelect={(date) => {
                        onChange(date);
                        setIsOpen(false);
                    }}
                    disabled={(date) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        const isSunday = date.getDay() === 0;
                        const isPast = date < today;

                        if (disablePastDates && isPast) return true;
                        if (disableSundays && isSunday) return true;

                        return false;
                    }}
                    fromYear={fromYear}
                    toYear={toYear}
                    initialFocus
                />
            </PopoverContent>
        </Popover>
    );
};